<template>
    <section>
        <v-text-field
        ref="nombreHabilidad"
        label="Nombre de la habilidad"
        v-model="habilidad.nombre"
        prepend-icon="mdi-tools"
        ></v-text-field>
        <v-checkbox
          label="¿Agregar grafica?"
          v-model="habilidad.mostrarGrafica"
        ></v-checkbox>
        <div v-if="habilidad.mostrarGrafica">
            <v-text-field
            label="Porcentaje"
            v-model="habilidad.porcentaje"
            prepend-icon="mdi-numeric"
            ></v-text-field>
            <v-color-picker
              dot-size="25"
              v-model="habilidad.color"
              swatches-max-height="200"
            ></v-color-picker>
        </div>
         <v-btn
          block
          dark
          :color="color"
          elevation="2"
          @click="agregarHabilidad"
        >
            <span v-if="editar">Aceptar</span>
            <span v-if="!editar">Añadir</span>
        </v-btn>
        <div v-if="habilidades.length > 0">
            <tabla-datos
            :encabezado="encabezadoTabla" 
            :datos="habilidades"
            @editar="editarHabilidad"
            @eliminar="eliminarHabilidad" 
            />   
        </div>
    </section>
</template>
<script>
    import TablaDatos from './TablaDatos'
    export default{
        name: "HabilidadesComponent",
        components: { TablaDatos },
        data: ()=>({
            encabezadoTabla: [
                {
                  text: "Habilidad",
                  value: "nombre",
                },
                {
                  text: "Porcentaje",
                  value: "porcentaje",
                },
                {
                  text: "Color",
                  value: "color",
                },
                {
                  text: "Opciones",
                  value: "opciones",
                },
            ],
            habilidades: [],
            habilidad: {
                nombre: "", 
                mostrarGrafica: false,
                porcentaje: "",
                color: ""
            },
            color: "indigo darken-4",
            editar: false,
            indice: -1,
        }),

        methods: {
            eliminarHabilidad(habilidad){
                this.habilidades.splice(this.habilidades.indexOf(habilidad), 1)
            },

            editarHabilidad(habilidad){
                this.color = "secondary"
                this.editar = true
                this.habilidad = habilidad
                this.indice = this.habilidades.indexOf(habilidad)
            },

            agregarHabilidad(){
                if(this.indice > -1){
                    Object.assign(this.habilidades[this.indice], this.habilidad)
                    this.editar = false
                    this.color = "indigo darken-4"
                    this.indice = -1
                } else {
                    this.habilidades.push(this.habilidad)
                }
                this.emitir()
                this.habilidad = {
                    nombre: "",
                    porcentaje: "",
                    mostrarGrafica: false,
                    color: ""
                }
                this.ponerFocus()
            },

            emitir(){
                this.$emit("habilidad", this.habilidades)
            },

            ponerFocus(){
                this.$refs["nombreHabilidad"].focus()
            }
        }
    }
</script>